export enum ContentWidth {
    NARROW = "narrow",
    STANDARD = "standard",
    WIDE = "wide",
}
